'use client';

import styled from 'styled-components';
import { colors } from '@/styles';
export { SplitFormWrapper } from '../styled';

export const ReadOnlyView = styled.div`
  /* display: flex;
  flex-direction: column;
  gap: 20px;
  border: 1px solid lime;
  padding: 20px; */

  .nowrap {
    white-space: nowrap;
  }

  .prompt-display {
    background: ${colors.primary.white};
  }
`;
